import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from '@app/components/components.module';
import { EaLoanAmortizationComponent } from './ea-loan-amortization/ea-loan-amortization.component';
import { EaLoanPaliersComponent } from './ea-loan-paliers/ea-loan-paliers.component';

const COMPONENTS = [EaLoanAmortizationComponent, EaLoanPaliersComponent];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [CommonModule, ReactiveFormsModule, ComponentsModule],
  exports: [...COMPONENTS],
})
export class EaLoanModule {}
